export default "__VITE_ASSET__CHixTZY8__"